import React from 'react';

function getSizeCss(level) {
    switch (level) {
        case 'small':
            return 'text-base lg:text-lg';
        case 'xsmall':
            return 'text-sm lg:text-base';
        case 'large':
            return 'text-lg lg:text-2xl';
        default:
            return 'text-base lg:text-lg';
    }
}
function getVariantCss(variant) {
    switch (variant) {
        case 'medium':
            return 'text-gray-600';
        case 'light':
            return 'text-white';
        case 'primary':
            return 'text-green';
        case 'dark':
            return 'text-black';
        default:
            return '';
    }
}
const Paragraph = React.forwardRef(({ children, className = '', size = 'medium', tagName = 'p', variant = 'default', ...props }, ref) => {
    const Component = tagName;
    return (React.createElement(Component, { ref: ref, className: [
            'font-sans',
            'prose',
            getSizeCss(size),
            getVariantCss(variant),
            className,
        ].join(' '), ...props }, children));
});

export { Paragraph };
//# sourceMappingURL=Paragraph.js.map
